const NESTED_SECTION_INDENTATION = 8;

export { NESTED_SECTION_INDENTATION };
